module.exports = __webpack_public_path__ + "media/images/locations/losangels-7aee7126cf801eb396b08d828a2d3a7b.jpg";